import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type DevicePlatform from '@linc-technologies/linced-common/enums/device-platform';

// Proto: notifications.Device.
export default class Device extends Model {
  declare [Type]: 'device';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr('number', { defaultValue: 0 })
  declare platform: EnumValue<typeof DevicePlatform>;

  @attr('string', { defaultValue: '' })
  declare displayName: string;

  @attr('string', { defaultValue: '' })
  declare make: string;

  @attr('string', { defaultValue: '' })
  declare model: string;

  @attr('string', { defaultValue: '' })
  declare osVersion: string;

  @attr('string', { defaultValue: '' })
  declare physicalId: string;

  @attr('string', { defaultValue: '' })
  declare token: string;

  @attr('string', { defaultValue: '' })
  declare fcmToken: string;
}
